import React, { useState, useEffect } from "react";
import { useAuth } from '../../../../../context/AuthContext';
import "./ticketDetail.css";
import { useTranslation } from "react-i18next";
import axios from "axios";
import Swal from 'sweetalert2'
import { useParams } from 'react-router-dom';
import { API_BASE_URL } from "../../../../../Helpers/apiConfig";

export const TicketDetail = () => {
    const params = useParams();
    const { user } = useAuth();
    const { t } = useTranslation();

    const [ticketDetail, setticketDetail] = useState(null);
    const [ticketAnswers, setticketAnswers] = useState([]);
    const [loading, setLoading] = useState(true);

    const [msg, setMsg] = useState("");
    const [answermsg, setanswerMsg] = useState("");
    const [answerloading, setanswerLoading] = useState(false);
    const [answerText, setAnswerText] = useState("");

    const formatDate = (val) => {
        if (!val) return "";
        // "2024-09-11T12:49:09.3272221" -> "11.09.2024 12:49"
        const [datePart, timePart] = val.split("T");
        if (!datePart) return val;

        const [y, m, d] = datePart.split("-");
        const time = timePart ? timePart.split(":").slice(0, 2).join(":") : "";
        return `${d}.${m}.${y} ${time}`;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setanswerLoading(true);

        try {
            const headerss = {
                accept: "*/*",
                "Content-Type": "application/json",
                "Access-Control-Allow-Credentials": "false",
                Authorization: "Bearer " + user.token,
            };

            const url = API_BASE_URL + "/admin/Ticket/ReplyTicket";

            const res = await axios({
                method: "GET",
                url: url,
                params: {
                    message: answerText,
                    ticketCode: params["id"],
                },
                headers: headerss,
            });

            if (res.status === 200 && res.data["success"]) {
                Swal.fire({
                    title: "Başarılı!",
                    icon: "success",
                    confirmButtonText: `Tamam`,
                });

                setanswerMsg("Başarıyla Cevaplandı.");
                setAnswerText("");

                // cevap gönderince tekrar yükleyelim
                fetchDetail();
            } else {
                const errorMessage = res.data["message"] || "Bir hata oluştu.";
                setanswerMsg(errorMessage);

                Swal.fire({
                    title: errorMessage,
                    icon: "error",
                    confirmButtonText: `Tamam`,
                });
            }
        } catch (err) {
            setanswerMsg("Beklenmedik bir hata oluştu.");
        } finally {
            setanswerLoading(false);
        }
    };

    const fetchDetail = async () => {
        setLoading(true);
        setMsg("");

        try {
            const headerss = {
                accept: "*/*",
                "Content-Type": "application/json",
                "Access-Control-Allow-Credentials": "false",
                Authorization: "Bearer " + user.token,
            };

            const url = API_BASE_URL + "/admin/Ticket/GetDetail";

            const res = await axios({
                method: "GET",
                url: url,
                params: { ticketCode: params["id"] },
                headers: headerss,
            });

            if (res.status === 200 && res.data["success"]) {
                const data = res.data["data"];

                // status çevirisi
                let statusText = "";
                if (data.ticket.status === "open") statusText = t("openedTicket");
                if (data.ticket.status === "waiting") statusText = t("waitingticket");
                if (data.ticket.status === "answered") statusText = t("answeredTickets");

                // Ticket detail state
                setticketDetail({
                    clientName: data.clientName,
                    ticket: {
                        message: data.ticket.message,
                        userId: data.ticket.userId,
                        title: data.ticket.title,
                        creationDate: data.ticket.creationDate,
                        ticketCode: data.ticket.ticketCode,
                        status: statusText,
                    },
                });

                // Conversations
                const answers = (data.ticketMessages || []).map((m) => ({
                    messageDate: m.messageDate,
                    message: m.message,
                    isItAnswer: m.isItAnswer ? t("userAnswer") : t("adminAnswer"),
                    isUser: m.isItAnswer, // user message mı
                }));

                setticketAnswers(answers);
            } else {
                setMsg(res.data["message"] || "Bir hata oluştu.");
            }
        } catch (err) {
            setMsg("Beklenmedik bir hata oluştu.");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchDetail();
    }, []);

    if (loading) {
        return (
            <div className="container my-4">
                <div className="ticket-loading">Yükleniyor...</div>
            </div>
        );
    }

    if (!ticketDetail) {
        return (
            <div className="container my-4">
                <div className="alert alert-warning">{msg || "Ticket bulunamadı."}</div>
            </div>
        );
    }

    return (
        <div className="container my-4 ticket-page">
            {/* Title */}
            <div className="text-center mb-4">
                <h2 className="fw-bold mb-1">{t("ticketDetail")}</h2>
                <p className="text-muted mb-0">{ticketDetail.clientName}</p>
            </div>

            {/* Ticket Info */}
            <div className="card shadow-sm border-0 ticket-info mb-4">
                <div className="card-body">
                    <div className="d-flex justify-content-between flex-wrap gap-3">
                        <div>
                            <h4 className="fw-bold mb-1">
                                {t("ticketTitle")}:{" "}
                                <span className="text-primary">{ticketDetail.ticket.title}</span>
                            </h4>
                            <p className="text-muted mb-2">{ticketDetail.ticket.message}</p>

                            <div className="d-flex gap-2 flex-wrap">
                                <span className="badge rounded-pill bg-light text-dark px-3 py-2">
                                    {t("ticketNo")}: {ticketDetail.ticket.ticketCode}
                                </span>

                                <span className="badge rounded-pill bg-light text-dark px-3 py-2">
                                    {t("userId")}: {ticketDetail.ticket.userId}
                                </span>

                                <span className="badge rounded-pill bg-primary px-3 py-2">
                                    {ticketDetail.ticket.status}
                                </span>
                            </div>
                        </div>

                        <div className="text-end">
                            <small className="text-muted d-block">{t("ticketCreatedDate")}</small>
                            <strong>{formatDate(ticketDetail.ticket.creationDate)}</strong>
                        </div>
                    </div>
                </div>
            </div>

            {/* Conversation */}
            <div className="card shadow-sm border-0 mb-4">
                <div className="card-header bg-white border-0">
                    <h5 className="fw-bold mb-0">{t("ticketconversation")}</h5>
                </div>

                <div className="card-body chat-area">
                    {ticketAnswers.length === 0 ? (
                        <div className="text-muted">Henüz mesaj yok.</div>
                    ) : (
                        ticketAnswers.map((dt, idx) => {
                            const isUser = dt.isUser; // kullanıcı mesajı
                            return (
                                <div
                                    key={idx}
                                    className={`chat-row ${isUser ? "right" : "left"}`}
                                >
                                    <div className={`chat-bubble ${isUser ? "user" : "admin"}`}>
                                        <div className="chat-meta">
                                            <strong>{dt.isItAnswer}</strong>
                                            <small>{formatDate(dt.messageDate)}</small>
                                        </div>
                                        <div className="chat-text">{dt.message}</div>
                                    </div>
                                </div>
                            );
                        })
                    )}
                </div>
            </div>

            {/* Reply */}
            <div className="card shadow-sm border-0">
                <div className="card-header bg-white border-0 text-center">
                    <h5 className="fw-bold mb-0">{t("ticketanswer")}</h5>
                </div>

                <div className="card-body">
                    {answermsg && (
                        <div className="alert alert-info py-2">{answermsg}</div>
                    )}

                    <form onSubmit={handleSubmit}>
                        <div className="mb-3">
                            <label className="form-label fw-semibold" htmlFor="answer">
                                {t("ticketanswer")}
                            </label>

                            <textarea
                                className="form-control ticket-textarea"
                                id="answer"
                                name="answer"
                                placeholder={t("answer")}
                                required
                                value={answerText}
                                onChange={(e) => setAnswerText(e.target.value)}
                                rows={5}
                            />
                        </div>

                        <div className="d-flex justify-content-center">
                            <button
                                type="submit"
                                disabled={answerloading}
                                className="btn btn-primary rounded-pill px-4 py-2 fw-bold ticket-send-btn"
                            >
                                {answerloading ? "Gönderiliyor..." : "Gönder"}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default TicketDetail;